import { TableCell, TableHead, TableRow, Typography } from '@/shared/ui';

import { LAST_TABLE_CELL_INDEX, TABLE_CELLS } from './legend.constants';

const LegendTableHeader = () => (
  <TableHead>
    <TableRow sx={{ '.MuiTableCell-head': { backgroundColor: 'gx.tileDark' } }}>
      <TableCell />
      {TABLE_CELLS.map((cell, index) => (
        <TableCell
          key={cell.key}
          align={cell.align}
          sx={{ pr: LAST_TABLE_CELL_INDEX === index ? 0 : 5, whiteSpace: 'nowrap' }}
          width={cell.width}
        >
          <Typography
            sx={theme => ({ color: theme.palette.gx.textDisabled })}
            variant='body2'
          >
            {cell.label}
          </Typography>
        </TableCell>
      ))}
    </TableRow>
  </TableHead>
);

export default LegendTableHeader;
